<template>
    <div style="height: 100%;">
        <van-nav-bar title="美发绩效" left-text="返回" left-arrow @click-left="historyBack"/>
        <div style="width: 100%;padding-bottom: 10px;margin-top: 5px;text-align: center">
            <el-radio-group v-model="jxPosition" @change="jxClick" size="mini">
              <el-radio-button label="2">本月</el-radio-button>
              <el-radio-button label="3">上月</el-radio-button>
            </el-radio-group>
          </div>
          <el-table :data="jxDatas" border :show-header="false" style="width: 100%" height="calc(100% - 2.5rem)">
            <el-table-column prop="date">
              <template slot-scope="scope">
                  <el-row>
                    <el-col :span="8">
                        {{scope.row.storename}}
                    </el-col>
                    <el-col :span="8">
                        总客人数:{{scope.row.number}}
                    </el-col>
                    <el-col :span="8">
                      有效客人:{{scope.row.yxnumber}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      上月到店人数:{{scope.row.befddcount}}
                    </el-col>
                    <el-col :span="8">
                      到店客人数:{{scope.row.ddcount}}
                    </el-col>
                    <el-col :span="8">
                        应到店次数:{{scope.row.ygddnumber}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      上月到店次数:{{scope.row.befddnumber}}
                    </el-col>
                    <el-col :span="8">
                      到店次数:{{scope.row.ddnumber}}
                    </el-col>
                    <el-col :span="8">
                      完成率:{{Math.round(scope.row.ddlv*100)}}%
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      合格率:{{Math.round(scope.row.lv *100)}}%
                    </el-col>
                  </el-row>
              </template>
            </el-table-column>
          </el-table>
    </div>
</template>
<script>
 export default {
    data(){
        return {
            storeid:localStorage.getItem("storeid"),
            jxDatas:[],
            jxPosition:"2",
            jxfromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
            jxtodate:this.$moment().endOf('month').format('YYYY-MM-DD'),
        }
    },
    created: function () {
        this.getCardTotalGuestInfo();
    },
    methods:{
        jxClick(e){
            if(e==2){
                this.jxfromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                this.jxtodate=this.$moment().endOf('month').format('YYYY-MM-DD');
            }
            else if(e==3){
                let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                this.jxfromdate=days+"-01";
                this.jxtodate=days+"-"+this.$moment(this.jxfromdate, "YYYY-MM-DD").daysInMonth();
            }
            this.getCardTotalGuestInfo();
        },
        getCardTotalGuestInfo(){
            this.$post("cashreport/getCardTotalGuestInfo",{storeid:this.storeid,fromdate:this.jxfromdate,todate:this.jxtodate,days:90,projectType:3,type:2}).then(res=>{
                if(res.sucess){
                    this.jxDatas=res.object;
                }
                else{
                    this.$message.error(res.message);
                }
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/page/manager/hairjx.vue